import React from 'react'
import { useTheme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'

const withMediaQuery = WrappedComponent => {
  return props => {
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down('xs'))
    return <WrappedComponent isMobile={isMobile} {...props} />
  }
}

export default withMediaQuery
